import React from 'react'
import { clsx } from 'clsx'
import LoadingSpinner from './LoadingSpinner'

const variantStyles = {
  primary: {
    background: 'linear-gradient(135deg, #1f9f93, #2fb6aa)',
    color: 'white',
    boxShadow: '0 10px 22px rgba(31,159,147,.22)',
    border: 'none',
  },
  secondary: {
    background: 'var(--color-glass)',
    color: 'var(--color-text)',
    border: '1px solid var(--color-border)',
  },
  success: {
    background: '#1dbf73',
    color: 'white',
    border: 'none',
  },
  warning: {
    background: '#ffb020',
    color: '#1a1a1a',
    border: 'none',
  },
  error: {
    background: '#e55353',
    color: 'white',
    border: 'none',
  },
  outline: {
    background: 'var(--color-glass)',
    color: 'var(--color-text)',
    border: '1px solid var(--color-border)',
    boxShadow: 'var(--shadow-btn)',
  },
  ghost: {
    background: 'transparent',
    color: 'var(--color-ghost-text)',
    border: 'none',
  },
}

const sizeMap = {
  xs: { padding: '6px 10px', fontSize: '11px' },
  sm: { padding: '8px 12px', fontSize: '12px' },
  md: { padding: '10px 16px', fontSize: '14px' },
  lg: { padding: '14px 24px', fontSize: '16px' },
  xl: { padding: '18px 32px', fontSize: '18px' },
}

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  leftIcon = null,
  rightIcon = null,
  className = '',
  as: Component = 'button',
  ...props
}) => {
  const vStyle = variantStyles[variant] || variantStyles.primary
  const sStyle = sizeMap[size] || sizeMap.md
  const isDisabled = disabled || loading

  return (
    <Component
      className={clsx(
        'inline-flex items-center justify-center font-bold rounded-xl transition-all focus:outline-none',
        isDisabled && 'opacity-50 cursor-not-allowed',
        className
      )}
      style={{
        ...vStyle,
        ...sStyle,
        textDecoration: 'none',
      }}
      disabled={Component === 'button' ? isDisabled : undefined}
      {...props}
    >
      {loading && (
        <LoadingSpinner
          size="xs"
          color={variant === 'outline' || variant === 'ghost' ? 'gray' : 'white'}
          className="mr-2"
        />
      )}

      {!loading && leftIcon && (
        <span className="mr-2">{leftIcon}</span>
      )}

      {children}

      {!loading && rightIcon && (
        <span className="ml-2">{rightIcon}</span>
      )}
    </Component>
  )
}

export default Button
